// Resource CTA presets. Destinations resolve against the member-auth state.
// The roadmap (personalized onboarding) flow is ONLY reachable from resource
// CTAs — it is never part of the trial or membership purchase flows.
export const CTA_PRESETS = {
    trial: {
        label: "Start Your 7-Day Free Trial",
        destination: (user) => (user ? "/trial" : "/register?trial=1"),
    },
    roadmap: {
        label: "Start Your 7-Day Free Trial",
        destination: () => "/roadmap",
    },
    showcase: {
        label: "See How SHREDxpro Works",
        destination: () => "/#showcase",
    },
    custom: { label: "", destination: (_user, url) => url || "/" },
    none: { label: "", destination: () => null },
};

export const RESOURCE_TYPES = {
    guide: "Educational Guide",
    meal_plan: "Meal Plan",
    workout: "Workout Guide",
    checklist: "Checklist / Blueprint",
    general: "General Lead Magnet",
};

export const resolveCta = (cta, user) => {
    if (!cta || cta.preset === "none") return null;
    const preset = CTA_PRESETS[cta.preset] || CTA_PRESETS.trial;
    const to = preset.destination(user, cta.url);
    const label = cta.label || preset.label || "Learn More";
    return to ? { to, label, preset: cta.preset } : null;
};
